import { useOktaAuth } from '@okta/okta-react';
import { isBffConfigured } from '../../config';

export interface CurrentUser {
  email: string | undefined;
  name: string | undefined;
}

export const LOCAL_DEV_USER: CurrentUser = { email: 'local@dev', name: 'Moi (local)' };

export function useCurrentUser(): CurrentUser {
  const { authState } = useOktaAuth() ?? {};
  if (!isBffConfigured()) return LOCAL_DEV_USER;
  if (!authState) return { email: undefined, name: undefined };

  // Email: read from accessToken (same source as the backend JWT authorizer)
  const accessClaims = authState.accessToken?.claims as Record<string, unknown> | undefined;
  const email = (accessClaims?.email ?? accessClaims?.sub) as string | undefined;

  // Display name: idToken carries full profile claims (given_name, family_name, name)
  const idClaims = authState.idToken?.claims;
  const givenName = idClaims?.given_name as string | undefined;
  const familyName = idClaims?.family_name as string | undefined;
  const fullName =
    (idClaims?.name as string | undefined) ||
    (givenName && familyName ? `${givenName} ${familyName}` : undefined) ||
    (idClaims?.preferred_username as string | undefined) ||
    email;

  return { email, name: fullName };
}
